import { assets } from 'constants/assets';
import { atom, useAtom } from 'jotai/index';

import { TokenAssetBase } from '../types';

type FtMetadataMap = Map<string, TokenAssetBase>;

const preSavedAssets: [string, TokenAssetBase][] = assets.map((asset) => [
  asset.contractAddress,
  {
    name: asset.name,
    symbol: asset.symbol,
    decimals: asset.decimals,
    image_uri: asset.image || undefined,
    address: asset.contractAddress,
    ref: asset.contractName,
  },
]);

const ftTokenMetadataAtom = atom<FtMetadataMap>(new Map(preSavedAssets));

export type FtMetadataStore = {
  ftMetadata: FtMetadataMap;
  addMetadata: (ftMetadata: TokenAssetBase) => void;
};

export const useFtMetadata = (): FtMetadataStore => {
  const [ftMetadata, setFtMetadata] = useAtom(ftTokenMetadataAtom);

  return {
    ftMetadata,
    addMetadata: (newMetadata: TokenAssetBase) =>
      setFtMetadata(ftMetadata.set(newMetadata.address, newMetadata)),
  };
};
